import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonicModule, LoadingController, ToastController} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';
import { AppEventService } from '../../app/app-events';
import { NavBarComponent } from '../../components/nav-bar/nav-bar';
import { BeerInfoComponent } from '../../components/beer-info/beer-info';
import { BeerAnalysisComponent } from '../../components/beer-analysis/beer-analysis';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AnalysisServiceProvider } from '../../providers/analysis-service/analysis-service';
import { LocationServiceProvider } from '../../providers/location-service/location-service';
import { UserDataProvider } from '../../providers/user-data/user-data';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { BeerProfileRequest, Venue } from '../../models/models';
import { Observable } from 'rxjs';
/**
 * Generated class for the BeerDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-beer-detail',
  templateUrl: 'beer-detail.html',
  styleUrls: ['./beer-detail.scss'],
  standalone: false,
  imports: [
    IonicModule,
    TranslateModule,
//    NavBarComponent,
    BeerInfoComponent,
    BeerAnalysisComponent,
    CommonModule,
    FormsModule
  ]
})
export class BeerDetailPage implements OnInit, OnDestroy, AfterViewInit {
  public static PATH: string = 'beerdetail';

  @ViewChild(BeerAnalysisComponent, { static: false }) analysisChild!: BeerAnalysisComponent;

  sourcetype: string;
  beer: any;
  bn: string;
  beerID: string;
  private selectedVenue: Venue = null;
  loading: any = null; // will contain the "loading" gui element reference
  showBeerSubscription;

  constructor(
    private translateService: TranslateService,
    public alertCtrl: AlertController,
    private router: Router,
    private bhutil: BhutilProvider,
    private analysisHolder: AnalysisHolderProvider,
    private events: AppEventService,
    private toastController: ToastController,
    private analysisService: AnalysisServiceProvider,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private beerService: BeerServiceProvider,
    private loadingCtrl: LoadingController,
    private beerAnalysisHolder: AnalysisHolderProvider,
    private refdata: RefdataProvider
  ) {
    this.log("constructor called")
  }

  ngOnInit(): void {
    this.log('ngOnInit called');
    let beer = this.bhutil.getStateParam(this.router,'beer');
    let sourcetype = this.bhutil.getStateParam(this.router, 'sourcetype');

    if (beer) {
      this.log("ngOnInit - beer = " + JSON.stringify(beer));
      this.updateModelBase(beer, sourcetype);
    }
    else
      this.log('ngOnInit: no beer found in state parameter');    

    this.showBeerSubscription = (showBeerData: any) => {
      this.updateModelBase(showBeerData.beer, showBeerData.sourcetype);
      this.loadAnalysesAndUpdateView();
    }
    this.events.subscribe("beer-list-entry:show:beer-detail", this.showBeerSubscription);
  }
  ngOnDestroy(): void {
    this.events.unsubscribe("beer-list-entry:show:beer-detail", this.showBeerSubscription);
  }

  ionViewWillEnter() {
    this.log('ionViewWillEnter called');
  }
  ionViewDidEnter() {
    this.log('ionViewDidEnter called');
    const state = window.history.state;
    if (state && state.data) {
        this.log('ionViewDidEnter: Received data from state: ' + JSON.stringify(state.data));
        this.showBeerSubscription(state.data);
    }
    else {
      if (state)
        this.log('ionViewDidEnter: Received no data from state: ' + JSON.stringify(state));
      else
        this.log('ionViewDidEnter: Received no state, window.history = ' + JSON.stringify(window.history));
    }
  }
  ionViewWillLeave() {
    this.log('ionViewWillLeave called');
  }
  ionViewDidLeave() {
    this.log('ionViewDidLeave called');
    this.beerID = undefined;
    this.beer = undefined;
    this.sourcetype = undefined;
    this.bn = undefined;
    this.selectedVenue = null;
  }
  public updateModelBase(beer: any, sourcetype: string) {
    this.log("updateModelBase called with beer = " + JSON.stringify(beer) + " and sourcetype = " + sourcetype)
    this.beer = beer;
    this.bn = beer.beer.name;
    this.sourcetype = sourcetype;
    this.beerID = beer.beer.id;
    if (this.analysisChild) this.analysisChild.updateBeerID(this.beerID);
  }
  public loadAnalysesAndUpdateView() {
    this.log("loadAnalysesAndUpdateView called");
    this.requestBeerProfile();
  }
  ngAfterViewInit(): void {
    this.log('ngAfterViewInit called');
    this.loadAnalysesAndUpdateView();    
  }

  ionViewCanLeave(): Promise<void> {
    this.log("request to leave page while localChangeDetected =" + this.analysisHolder.localChangeDetected);
    return new Promise((resolve, reject) => {
      if (this.analysisHolder.localChangeDetected) {
        this.log("local change detected, inform user");
        let alertProm = this.alertCtrl.create({
          header: this.translateService.instant("OPENPAGE.YOUR_CURRENT_ANALYSIS_HAS_NOT_BEEN_SAVED_YET"),
          message: this.translateService.instant("OPENPAGE.DO_YOU_WANT_TO_SAVE_IT_NOW"),
          backdropDismiss: false,
          buttons: [
            {
              text: this.translateService.instant("OPENPAGE.YES_SAVE_AND_CLOSE_ANALYSIS"),
              handler: () => {
                this.log('yes clicked');
                this.events.publish("save:beer");
                resolve();
              }
            },
            {
              text: this.translateService.instant("OPENPAGE.NO_CLOSE_ANALYSIS_WITHOUT_SAVING"),
              /*role: 'cancel',*/
              handler: () => {
                this.log('no clicked');
                this.analysisHolder.cancelPendingSave();
                resolve();
              }
            },
            {
              text: this.translateService.instant("OPENPAGE.CANCEL_RETURN_TO_CURRENT_ANALYSIS"),
              role: 'cancel',
              handler: () => {
                this.log('cancel clicked');
                reject();
              }
            }
          ]
        });
        alertProm.then((alert) => alert.present());
      } else {
        resolve();
      }
    })
  }

  private requestBeerProfile() {
      //debugger;
      this.log("requestBeerProfile called with beerID = " + this.beerID);
      let latitude = this.locationService.latitude;
      let longitude = this.locationService.longitude;

      // requesting a beer, so deactive the previous
      this.beerAnalysisHolder.deactivateBeer();
  
      this.userData.getUserID()
        .then((userID) => {
          let beerProfileRequest = new BeerProfileRequest(userID, latitude, longitude, this.beerID, (this.selectedVenue ? this.selectedVenue.id : null));
  
          if (this.loading == null) {
            var loadingProm = this.loadingCtrl.create({
              message: this.translateService.instant('GENERAL.PLEASE_WAIT')
            });
            loadingProm.then((loadingControl) => {
              this.loading = loadingControl;
                this.loading.present().then(() => {
                  setTimeout(() => {
                    this.dismissLoading();
                  }, 5000);
                  this.beerService.getBeerProfile(beerProfileRequest).subscribe(
                    beerProfileResponse => {
                      this.log("beerService.getBeerProfile: beerProfileResponse = " + JSON.stringify(beerProfileResponse));
                      //process the beer profile
                      this.log("[beer-detail] calling processBeerProfileResponseFromServer");
                      this.processBeerProfileResponseFromServer(beerProfileResponse, userID);
                      this.dismissLoading();
                    },
                    err => {
                      this.log(err);
                      this.dismissLoading();
                    });
                });
            });
          }
        }
        );
    }
  private   dismissLoading() {
    if (this.loading != null) {
      this.loading.dismiss();
      this.loading = null;
    }
  }
  private processBeerProfileResponseFromServer(beerProfileResponse: any, userID: string) {
    this.log("processBeerProfileResponseFromServer called")
    // Logic here runs after the paint
    let beerProfile: any = beerProfileResponse;

    // Marshall the responses to the right type
    let analyses = new Map<string, any>(Object.entries(beerProfile.analysis));
    //update the list of analyses
    this.beerAnalysisHolder.loadAnalyses(userID, this.beerID, analyses, beerProfile.beerstats, beerProfile.similarbeers);

    this.updateView();

  }
  public updateView() {
    this.log("updateView called");
    // this.events.publish("beer-detail:show:beer-info", { ...this.beer });
    this.events.publish("beer-detail:show:beer-analysis", { ...this.beer.beer });
  }
  private log(s: string): void {
    console.log("[beer-detail] " + s);
  }
}
